module.exports = __webpack_public_path__ + "static/media/gangbot-0.5307fc3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Gangbot/gangbot-0.jpg
// module id = 193
// module chunks = 0